
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { ManagerService } from '@app/_core/services/manager.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
@Component({
  selector: 'app-fax-viewer',
  standalone: true,
  imports: [CommonModule],   // <-- add this
  templateUrl: './fax-viewer.component.html',
  styleUrls: ['./fax-viewer.component.scss']
  
})

export class FaxViewerComponent {
  @ViewChild('pdfViewer', { static: false }) pdfViewer!: ElementRef<HTMLIFrameElement>;
  isLoading = true;
  errorMsg?: string;
  //private blobUrl?: string;
  filePath: any;
  blobUrl:any;
  pdfUrl: SafeResourceUrl;

  constructor(private router: Router,private sanitizer: DomSanitizer, private managerService: ManagerService){}

  ngOnInit(): void {
    //debugger;
    this.filePath = decodeURIComponent(this.router.url.split('?').pop().split("=").pop());
    console.log("File Path: ", this.filePath);
  }

  ngAfterViewInit() {
    this.managerService.getRecordingFiles(this.filePath).subscribe(response => {
      const binaryData = 'data:' + response.MimeType + ';base64,' + response.result;
      const binary = Utils.convertDataURIToBinary(binaryData);
      const blob = new Blob([binary], { type: response.MimeType });
      this.blobUrl = URL.createObjectURL(blob);
      this.pdfViewer.nativeElement.src = this.blobUrl;
    });
   }
}
